import { render, staticRenderFns } from "./IconBtnExit.vue?vue&type=template&id=250e3469"
import script from "./IconBtnExit.vue?vue&type=script&lang=js"
export * from "./IconBtnExit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports